import axios from "./axios"; // Import the centralized Axios instance

const state = {
  bill_of_materials: [],
};

const getters = {
  allBillOfMaterials: (state) => state.bill_of_materials,
};

const actions = {
  async fetchBillOfMaterials({ commit }) {
    try {
      const response = await axios.get("/bill-of-material", { params: { page: 1, limit: 25 } });
      commit("setBillOfMaterials", response.data);
    } catch (error) {
      console.error("Failed to fetch bill_of_materials:", error);
    }
  },
  async createBillOfMaterial({ commit }, bill_of_material) {
    try {
      const response = await axios.post("/bill-of-material", bill_of_material);
      commit("addBillOfMaterial", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create bill_of_material:", error);
      throw error;
    }
  },
  async fetchBillOfMaterialById(_, id) {
    try {
      const response = await axios.get(`/bill-of-material/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch bill_of_material:", error);
      throw error;
    }
  },
  async updateBillOfMaterial({ commit }, bill_of_material) {
    try {
      const response = await axios.put(`/bill-of-material/${bill_of_material.id}`, bill_of_material);
      commit("updateBillOfMaterial", response.data);
    } catch (error) {
      console.error("Failed to update bill_of_material:", error);
      throw error;
    }
  },
  async deleteBillOfMaterialById({ commit }, id) {
    try {
      const response = await axios.delete(`/bill-of-material/${id}`);
      commit("removeBillOfMaterial", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete bill_of_material:", error);
      throw error;
    }
  },
};

const mutations = {
  setBillOfMaterials(state, bill_of_materials) {
    state.bill_of_materials = bill_of_materials.data; // Ensure this matches your API's response structure
  },
  addBillOfMaterial(state, bill_of_material) {
    state.bill_of_materials.push(bill_of_material);
  },
  updateBillOfMaterial(state, updatedBillOfMaterial) {
    const index = state.bill_of_materials.findIndex(
      (bill_of_material) => bill_of_material.id === updatedBillOfMaterial.id
    );
    if (index !== -1) {
      state.bill_of_materials.splice(index, 1, updatedBillOfMaterial);
    }
  },
  removeBillOfMaterial(state, id) {
    state.bill_of_materials = state.bill_of_materials.filter(
      (bill_of_material) => bill_of_material.id !== id
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
